document.addEventListener("DOMContentLoaded", function () {
  const radioButtons = document.querySelectorAll('input[name="field"]');

  // Trigger the change event for the already selected radio button
  const selectedRadio = document.querySelector('input[name="field"]:checked');
  if (selectedRadio) {
    selectedRadio.dispatchEvent(new Event("change"));
  }

  // Object mapping each radio button to specific elements
  const targetElements = {
    "ui-frontend": document.querySelectorAll(".fl-fd"),
    "video-motion": document.querySelectorAll(".fl-v"),
    "graphic-design": document.querySelectorAll(".fl-gd"),
    photography: document.querySelectorAll(".fl-ph"),
  };

  radioButtons.forEach((radio) => {
    radio.addEventListener("change", function () {
      // First, add the class back to ALL elements
      Object.values(targetElements).forEach((elements) => {
        elements.forEach((el) => el.classList.add("visual-filter")); // Add back the class
      });

      // Then, remove the class ONLY from the elements linked to the selected radio button
      const elementsToModify = targetElements[this.id];

      if (elementsToModify) {
        elementsToModify.forEach((element) => {
          element.classList.remove("visual-filter"); // Remove class from the selected radio's elements
        });
      }
    });
  });
});
